import { render, staticRenderFns } from "./wCard.vue?vue&type=template&id=fb78cfa8&scoped=true&"
import script from "./wCard.vue?vue&type=script&lang=js&"
export * from "./wCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb78cfa8",
  null
  
)

export default component.exports